<template>
  <p class="e-hint">
    <b>{{ title }}</b>
    <slot></slot>
  </p>
</template>

<script>
	export default {
		name: "e-hint",
    props: {
		  title: String,
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/hint/hint.vue